import "../../App.css";

import {
  Box,
  Flex,
  Grid,
  GridItem,
  HStack,
  Heading,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";

import { AuthService } from "src/rest/authService";
import { EnglishLabels } from "../../common/constants/englishLabels";
import { GlobalLangSelector } from "src/common/globalLangSelector";
import { HindiLabels } from "src/common/constants/hindiLabels";
import LogoutIcon from "src/resources/icons/LogoutIcon";
import { MksLogo } from "../../resources/icons";
import { RootState } from "src/store/store";
import {UserAvatarIcon} from "../../resources/icons";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const HeaderComponent: React.FC = () => {
  const globalInfo = useSelector((state: RootState) => state.globalInfo);
  const { globalLanguage } = globalInfo;
  const isHindiLabels = globalLanguage === "HI";
  const navigate = useNavigate();

  const handleLogout = async (): Promise<void> => {
    try {
      await AuthService.logout();
    } catch (error) {
      console.error("Logout failed:", error);
    }
    localStorage.removeItem("userRole");
    localStorage.removeItem("authToken");
    const bc = new BroadcastChannel("auth");
    bc.postMessage("logout");
    bc.close();
    sessionStorage.clear();
    navigate("/login", { replace: true, state: { fromApp: true } });
  };

  const [isMobile] = useMediaQuery("(max-width: 550px)");

  return (
    <Flex width="100%" mx={2}>
      <Grid width="100%" templateColumns="repeat(2, 1fr)">
        <GridItem justifySelf="start">
          <HStack gap={0} alignItems="end">
            <Box mt={2} height="4.5rem" width="4.5rem">
              <MksLogo />
            </Box>
            <Box mb={2} hidden={isMobile} ml={4}>
              <Heading
                lineHeight="100%"
                width="11.8rem"
                color="#4A2C2A"
                fontWeight="700"
                fontSize="1.5rem"
                letterSpacing="-1px"
              >
                {isHindiLabels
                  ? HindiLabels.Mourya_Community_Label
                  : EnglishLabels.Mourya_Community_Label}
              </Heading>
            </Box>
          </HStack>
        </GridItem>

        <GridItem alignSelf="end" justifySelf="end">
          <HStack>
            <GlobalLangSelector />
            <Menu>
              <MenuButton>
                <UserAvatarIcon width={55} height={55} />
              </MenuButton>
              <MenuList minWidth={10}>
                <MenuItem onClick={handleLogout}>
                  <HStack alignItems="center">
                    <LogoutIcon />
                    <Text mb={1}>Logout</Text>
                  </HStack>
                </MenuItem>
              </MenuList>
            </Menu>
          </HStack>
        </GridItem>
      </Grid>
    </Flex>
  );
};

export default HeaderComponent;
